<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../assets/images/pop/dd/dingd.jpg" class="createNxs createNx1" v-if="status==1">
      <div class="createNxbtn" @click="nextcreateNx(status)">
        {{status==1?"我知道了":"我知道了"}}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]" />
    <div class="h-piece" style="margin:20px">
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>订单信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true" ref="form0" :model="order" class="demo-ruleForm h-formbLine">
              <el-form-item label="订单类型" class="h-elformWrap-2">
                <el-input v-model="xsqyStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="this.order.cuname" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建时间" class="h-elformWrap-2">
                <el-input v-model="this.order.cdate" readonly></el-input>
              </el-form-item>
              <el-form-item label="业务原因" prop="businessReason" class="h-elformWrap-2" v-if="showRent" :rules="[{ required: true, message: '请选择业务原因', trigger: 'blur'},]">
                <brselect clearable category="business_reason" :v="order.businessReason" v-model="order.businessReason"></brselect>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------合同信息-------------------------------------------------------------------->
      <div class="h-pieceIn2" v-if="showJzx">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>合同信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true" ref="form0" :model="order" class="demo-ruleForm h-formbLine">
              <el-form-item label="合同名称" class="h-elformWrap-2">
                <el-input v-model="contract.contractName" readonly></el-input>
              </el-form-item>
              <el-form-item label="合同类型" class="h-elformWrap-2">
                <el-input readonly v-model="contract.contractCatecoryName"></el-input>
              </el-form-item>
              <el-form-item label="租赁类型" class="h-elformWrap-2" prop="zltype">
                <el-select v-model="contract.zltype" placeholder="请选择" :clearable="true" filterable disabled style="width:100%">
                  <el-option label="房屋" value="1"></el-option>
                  <el-option label="疫苗车" value="2"></el-option>
                  <el-option label="集装箱" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户名称" class="h-elformWrap-2">
                <el-input v-model="contract.customerName" readonly></el-input>
              </el-form-item>
              <el-form-item label="租赁方式" class="h-elformWrap-2" prop="rentType">
                <el-select v-model="contract.rentType" placeholder="请选择" :clearable="true" filterable :disabled="!this.order.updateFlag" @change="getRentTime()" style="width:100%">
                  <el-option label="Round Trip" value="roundtrip"></el-option>
                  <el-option label="长期" value="longterm"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="租赁天数" class="h-elformWrap-2" prop="rentType">
                <el-select v-model="contract.rentTime" :v="contract.rentTime" @change="stRentTime()" disabled placeholder="请选择" style="width:100%">
                  <el-option v-for="(item) in rentTimeList" :key="item.rentTerm" :label="item.rentTerm" :value="item.rentTerm">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同开始时间" class="h-elformWrap-2">
                <el-input v-model="contract.contractStarttime" readonly></el-input>
              </el-form-item>
              <el-form-item label="合同结束时间" class="h-elformWrap-2">
                <el-input v-model="contract.contractEndtime" readonly></el-input>
              </el-form-item>
              <el-form-item label="是否附加损坏豁免" class="h-elformWrap-2" prop="isShhm">
                <el-select v-model="contract.isShhm" placeholder="请选择" :clearable="true" filterable disabled style="width:100%">
                  <el-option label="是" value=1></el-option>
                  <el-option label="否" value=0></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="提箱地点" class="h-elformWrap-2">
                <el-input v-model="contract.rentPlace" readonly></el-input>
              </el-form-item>
              <el-form-item label="还箱地点" class="h-elformWrap-2">
                <el-input v-model="contract.returnPlace" readonly></el-input>
              </el-form-item>
              <el-form-item label="是否加急" class="h-elformWrap-2" prop="isJj">
                <el-select v-model="contract.isJj" placeholder="请选择" :clearable="true" filterable disabled style="width:100%">
                  <el-option label="是" value=1></el-option>
                  <el-option label="否" value=0></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单是否变更" class="h-elformWrap-2" prop="isChange">
                <el-select v-model="order.isChange" placeholder="请选择" :clearable="true" filterable style="width:100%">
                  <el-option label="是" value=1></el-option>
                  <el-option label="否" value=0></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单是否取消" class="h-elformWrap-2" prop="isCancel">
                <el-select v-model="order.isCancel" placeholder="请选择" :clearable="true" filterable style="width:100%">
                  <el-option label="是" value=1></el-option>
                  <el-option label="否" value=0></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="实际还箱日期" class="h-elformWrap-2" width="100%" prop="rentDate">
                <div class="block">
                  <el-date-picker v-model="order.returnTime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="请选择实际还箱日期">
                  </el-date-picker>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>客户信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form :model="order" ref="form1" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item prop="soldToName" label="售达方名称" :rules="[{ required: true, message: '请输入售达方名称', trigger:['change', ' blur','input']},]" class="h-elformWrap-2">
                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                  <i v-if="selectDailishang" class="el-icon-search el-input__icon" slot="suffix" @click="openShoudf">
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2">
                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
              </el-form-item>
              <el-form-item prop="shipToAreaCode" label="送达方区域" :rules="[{ required: true, message: '送达方区域不能为空', trigger: 'change'},]" class="h-elformWrap-2">
                <el-select v-model="order.shipToAreaCode" :v="order.shipToAreaCode" filterable placeholder="请选择" style="width:100%" @change="getAreaList">
                  <el-option v-for="(item,index) in QYcountryList" :key="index" :label="`[${item.areacode}]${item.areaname}`" :value="item.areacode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="currencyCode" label="币种" :rules="[{ required: true, message: '请输入币种', trigger: 'change'},]" class="h-elformWrap-2">
                <mdmselect clearable category="YLCurrency" :showcode="true" disabled :v="order.currencyCode" v-model="order.currencyCode"></mdmselect>
              </el-form-item>
              <el-form-item prop="customerChannelCode" label="客户渠道" :rules="[{ required: true, message: '请输入客户渠道', trigger:['change', ' blur','input']},]" class="h-elformWrap-2">
                <el-select v-model="order.customerChannelCode" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in customerChannelListFilter" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <div class="h-table h-mrt30 ljjtablepaddings2" style="margin: 10px 20px 0 10px;">
        <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
          <h1 class="h1">产品信息</h1>
          <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-left: 50px;" @click="showProcuct1" v-if="showaddProductRow">选择产品
          </el-button>
        </div>
        <div v-for="(obj,index) in companyInfoList" :key="index">
          <div v-if="getProductlist(obj.code).length>0" style="margin-bottom: 20px;">
            <span style="color: #4a4a4a" v-if="!chooseGscode">{{ obj.name }}</span>
            <el-select v-model="zhidanGsCode" placeholder="请选择" @change="chooseGsCode($event),$forceUpdate()" style="width:320px" v-if="chooseGscode">
              <el-option v-for="item in zhidanCompanycode" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
            <el-table ref="multipleTable" :data="getProductlist(obj.code)" stripe border style="width: 100%">
              <el-table-column type="index" label="#" width="30"></el-table-column>
              <el-table-column prop="billingStarttime" label="开票开始日期" v-if="showJzx" :show-overflow-tooltip="true" width="150">
                <template slot-scope="scope">
                  <div class="block">
                    <el-date-picker v-model="scope.row.billingStarttime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择开票开始日期--">
                    </el-date-picker>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="billingEndtime" label="开票结束日期" v-if="showJzx" :show-overflow-tooltip="true" width="150">
                <template slot-scope="scope">
                  <div class="block">
                    <el-date-picker v-model="scope.row.billingEndtime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择开票结束日期--">
                    </el-date-picker>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="proModelName" label="产品大类" :show-overflow-tooltip="true" width="80">
              </el-table-column>
              <el-table-column min-width="150" prop="shareModelCode" v-if="!secondAgent" :show-overflow-tooltip="true" label="共享大类">
                <template slot-scope="scope">
                  <el-select class="h-tableInput" v-if="scope.row.proType=='OEM'&&scope.row.smList.length>0" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)" placeholder="请选择" clearable>
                    <el-option v-for="item in scope.row.smList" :key="item.shareModelCode" :label="item.shareModelName" :value="item.shareModelCode">
                    </el-option>
                  </el-select>
                  <el-select class="h-tableInput" v-if="scope.row.proType!='OEM'||scope.row.smList.length==0" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)" disabled placeholder="请选择" clearable>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" width="95">
              </el-table-column>
              <el-table-column min-width="150" prop="materialName" :show-overflow-tooltip="true" label="产品名称">
                <template slot-scope="scope">
                  <div style="text-align: left;">
                    {{scope.row.materialName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column min-width="150" prop="oemDesc" :show-overflow-tooltip="true" label="规格型号">
                <template slot-scope="scope">
                  <div style="text-align: left;">
                    {{scope.row.oemDesc}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="factory" label="产地" :show-overflow-tooltip="true" width="60">
              </el-table-column>
              <el-table-column prop="proNumber" label="订单数量" width="80">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.proNumber" placeholder="请输入" class="DshuR h-tableInput" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="cwddh" label="财务订单号" v-if="showRent" min-width="140">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.cwddh" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="currencyCode" label="币种" :show-overflow-tooltip="true" v-if="!secondAgent && showJzx" width="90">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{scope.row.currencyCode}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="priceType" label="费用名称" v-if="showJzx" width="150" :show-overflow-tooltip="true">
                <template scope="scope">
                  <brselect clearable category="price_type" disabled :v="scope.row.priceType" @change="getRentPrice($event,scope.$index)" v-model="scope.row.priceType"></brselect>
                </template>
              </el-table-column>
              <el-table-column prop="proBenchmarkPrice" label="基准价" :show-overflow-tooltip="true" v-if="!secondAgent" width="70">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{scope.row.proBenchmarkPrice}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="finalPrice" label="成交价" :show-overflow-tooltip="true" width="70">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{ scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice ||
                      scope.row.proBenchmarkPrice*scope.row.discount ||
                      scope.row.proBenchmarkPrice).plus(scope.row.extraPrice||0).toFixed(2).toString() }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="jinejjz" label="净价值" v-if="!secondAgent" width="70">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{ scope.row.jinejjz = new
                  big(scope.row.finalPrice).div(scope.row.taxRate).toFixed(2).toString()}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="totalprice" label="总价" v-if="!secondAgent" width="70">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{ scope.row.totalprice = new big(scope.row.proNumber ||
                      0).times((scope.row.finalPrice||0)).toFixed(2).toString() }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="note1" label="备注" min-width="160">
                <template slot-scope="scope">
                  <el-input class="h-tableInput" v-model="scope.row.note1" placeholder="请输入" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" class="h-tableLink h-btn" @click="deleteThis(scope.row)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="h-tableAdd" @click="adds" v-if="showJzx&&obj.code=='1JC0'">
              <a>新增费用类型</a>
            </div>
            <div class="jieguo w-newIcon" v-show="!secondAgent">
              <span class="jieguo_label">订单总价</span>
              <span class="jieguo_value">{{  getOrderName(obj.code).orderPrice }}</span>
              <span v-if="!secondAgent" class="jieguo_label">现金余额</span>
              <span v-if="!secondAgent" class="jieguo_value">{{ getOrderName(obj.code).xianjye }}</span>
              <span v-if="!secondAgent" class="jieguo_label">现金占用</span>
              <span v-if="!secondAgent" class="jieguo_value">{{ getOrderName(obj.code).orderPriceXj = new big(getOrderName(obj.code).orderPrice||0).minus(getOrderName(obj.code).orderPriceXd||0).toString() }}</span>
              <span v-if="!secondAgent" class="jieguo_label">现金欠款</span>
              <span v-if="!secondAgent" class="jieguo_value">{{ getOrderName(obj.code).orderPriceXjQk = ((new big(getOrderName(obj.code).xianjye||0).minus(getOrderName(obj.code).orderPriceXj||0))>0 ? 0:(new big(getOrderName(obj.code).xianjye||0).minus(getOrderName(obj.code).orderPriceXj||0).toString())) }}</span>
              <span v-if="!secondAgent" class="jieguo_label">信贷选择</span>
              <span v-if="!secondAgent" class="jieguo_value">
                <el-select class="ljjsales" v-model="getOrderName(obj.code).creditid" clearable placeholder="请选择" @change="creditChange($event,obj.code)">
                  <el-option v-for="item in getOrderName(obj.code).creditData" :key="item.id" :label="item.id!=null ? `信贷总额：${ item.quota }`:`请选择` " :value="item.id">
                    <div style="color: #8492a6; font-size: 12px" v-if="item.id!=null">
                      <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                      <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                    </div>
                  </el-option>
                </el-select>
              </span>
              <span v-if="!secondAgent" class="jieguo_label">信贷占用</span>
              <span v-if="!secondAgent" class="jieguo_value">{{getOrderName(obj.code).orderPriceXd }}</span>
              <span class="jieguo_label">净价值</span>
              <span class="jieguo_value">{{getOrderName(obj.code).orderNetWorth}}</span>
            </div>
          </div>
        </div>
      </div>
      <!--售达方-->
      <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag :usercode="null" :xmcode="xmcode" :ddlx="ddlx" :xszz="order.saleGroupCode" title="选择售达方" />
      <wxwl :visible.sync="showwuliaodialog1" v-if="showwuliaodialog1" @choseObj="choseWuliao1" :usercode="order.soldToCode" :ddlx="'1,8'" :xmcode="xmcode" :nwsale="'2'" :customerChannelCode="order.customerChannelCode" :areaCode="order.salesregion" title="选择物料" />
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
    <div v-if="taskstatus=='0'">
      <div class="anniu" v-if="!resubmit">
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
        </el-row>
      </div>
      <div class="anniu" v-else>
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
          <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "@/api/SystemService";
import _ from "loadsh";
import uploaddown from "@/utils/updownfile";
import big from "big.js";
import shoudf from "@/components/dialog/selectshdf.vue";
import wxwl from "@/components/dialog/wxwl.vue";

export default {
  components: { wxwl, shoudf },
  data () {
    return {
      showdelProductRow: true,
      showOrhide: false,
      checked: true,
      status: 1,
      toshow: 'createNxOrder2',
      testID: '',
      showRent: false,
      xmcode: null,
      zlUpdateFlag: false,
      submitChongfuFlag: true,
      //合同信息
      contract: "",
      zulinPrice: '',
      QYcountryList: [],
      customerChannelListFilter: [],
      //对象
      order9390: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9370: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1D90: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1JC0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9391: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1RK0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1R60: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order0PN0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S00: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S40: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order44U0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order45K0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order: {
        id: null, // 主键
        orderMainContract: null, // 主合同编号
        orderSubContract: null, // 分合同编号
        orderProjectCode: null, // 项目编号
        orderProjectName: null, // 项目名称
        projectDescription: null, // 项目描述
        orderCategory: null, // 订单类型
        orderCategory1: null, // 订单详细类型:
        saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织 1D90-海乐苗（青岛）智能物联有限公司 1JC0-青岛鸿鹄航空科技有限公司
        disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
        zCode: null, // 分销渠道编码-子编码
        customerChannelCode: null, // 客户渠道
        isStockUp: null, // 是否备货      1：是；0：否
        orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
        instid: null, // 流程id
        taskId: null, // 流程id
        tuihyy: null, // 退货原因
        tuihyydes: null, // 退货原因说明
        contactName: null, // 联系人名称
        collageTypeCode: null,
        receivedTime: null, // 预计收货时间
        soldToCode: null, // 售达方编码
        soldToName: null, // 售达方名称
        salesregion: null, // 售达方销售区域
        salesregionName: null, // 售达方销售区域名称
        soldToAreaCode: null, // 售达方地区编码
        soldToAreaName: null, // 售达方地区名称
        shipToCode: null, // 送达方编码
        shipToName: null, // 送达方名称
        shipToAreaCode: null, // 送达方地区编码
        invoiceCode: null, // 开票方编码
        payerCode: null, // 付款方编码
        currencyCode: null, // 币种编码
        orderPrice: 0, // 订单总价
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        poId: null, // PO号
        areaId: null, // 区域详情表关联id
        dcCode: null, // 配送中心编码
        toProvincesCode: null, // 送达省份编码
        toCityCode: null, // 送达城市编码
        note: null, // 订单备注
        note1: null,//产品备注
        postcode: null, // 邮政编码
        firsttelephone: null, // 第一个电话
        secondtelephone: null, // 第二电话
        extraPrice: null, // 定制加价
        customized: null, // 定制需求
        sapsended: null, // 是否已提交sap,1-是,0-否
        toAddress: null, // 收货地址
        toCompanyname: null, // 送达方公司全称
        posnr: null, // 外销:销售和分销凭证的项目号
        inco1: null, // 外销:国际贸易条款 (部分1)
        inco2: null, // 外销:国际贸易条款 (部分2)
        submitflag: null,//提交标志
        categoryName: null,
        category1Name: null,
        saleGrputName: null,
        disChannelName: null,
        zcodeName: null,
        expoPrice: null,//展会价
        fktj: null, //付款条件
        costCenter9390: null,
        costCenter9370: null,
        costCenter1D90: null,
        costCenter1JC0: null,
        costCenter1RK0: null,
        costCenter9391: null,
        costCenter1R60: null,
        costCenter0PN0: null,
        costCenter1S00: null,
        costCenter1S40: null,
        costCenter44U0: null,
        costCenter45K0: null,
        businessReason: null,

        kucun: null,//库存地点
        lkfileUrl: null,
        fileUrl: [],
        sgFileUrl: null,
        csFileUrl: null,
        isStandard: '',
        isZl: '',
        mfFileUrl: null,
        agentLevel: "",
        zmFile: null,
        upload2: [],
        isChange: 0,
        isCancel: 0,
        returnTime: null,
        zltype: null,
        updateFlag: false,
        hhxmCode: null,//厚宏项目id
        startTime: null,//质保开始时间
        endTime: null,//质保结束时间
      },
      ddlx: null,
      selectDailishang: true,
      //所用公司信息
      companyInfoList: [],
      customerChannelList: [],
      //行项目
      productlist9390: [],
      productlist9370: [],
      productlist1D90: [],
      productlist1JC0: [],
      productlist9391: [],
      productlist1RK0: [],
      productlist1R60: [],
      productlist0PN0: [],
      productlist1S00: [],
      productlist1S40: [],
      productlist44U0: [],
      productlist45K0: [],
      allProductlist: [],
      showJzx: false,
      rentTimeList: [],//是否直单用户
      zhidanflag: 0,
      companycodes: "",
      zhidanCompanycode: [],
      isBlood: 0,
      //经销商级别(一级二级)
      agentLevel: "",
      //是否二级经销商
      secondAgent: false,
      resubmit: false,
      instid: null,
      taskstatus: 0,
      chooseGscode: false,
      zhidanGsCode: "",
      showshdfdialog: false,
      showaddProductRow: true,
      showwuliaodialog1: false,
      showhistory: false,
    }
  },
  created () {
    //所用公司信息
    this.companyInfoList = this.$store.getters.dictlist("company_info");
    this.customerChannelListFilter = this.$store.getters.dictlist("sales_region");
    this.companyInfoList.forEach((obj) => {
      this.$set(this.allProductlist, 'productlist' + obj.code, [])
      //动态生成监听
      this.$watch('productlist' + obj.code, (newValue, oldValue) => {

        //计算总金额
        this['order' + obj.code].orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
        //计算总净价值
        this['order' + obj.code].orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
        //重新计算信贷
        if (this['order' + obj.code].creditid) {
          this.creditChange(this['order' + obj.code].creditid, obj.code);
        }
      }, { deep: true, immediate: true });

    })
    if (this.$route.query.id == '' || this.$route.query.id == undefined) {
      this.testID = this.$route.query.ywid
    } else {
      this.testID = this.$route.query.id
    }
    this.showzhezhao()
    let id = this.$route.query.ywid;
    let instid = this.$route.query.instid;
    let taskid = this.$route.query.taskid;
    let taskstatus = this.$route.query.taskstatus | 0;
    let chongXinTiJiao = this.$route.query.chongXinTiJiao;
    if (id && instid) {
      this.resubmit = true;
      if (!chongXinTiJiao) {
        this.showaddProductRow = false;
        this.showdelProductRow = false;
      }
      this.instid = instid;
      this.taskstatus = taskstatus;
      this.order.taskId = taskid;
      if (taskstatus == '1') {
        // 直接设置经销商
        this.selectDailishang = false;
        const parent = document.querySelector(".input");
        parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
        //2.在设置input属性
        //获取input
        const input = document.querySelector(".input input");
        //设置input的属性为false
        input.disabled = false;
      }
    }
    if (this.$route.query.agentLevel == 2) {
      this.getSecondOrder(id || this.$route.query.id);
    } else {
      if (this.$route.query.zltype == '3') {
        this.getOrderZl(this.$route.query.id);
      } else {
        this.getOrder(id || this.$route.query.id);
      }
    }
    //判断能否显示价格信息
    //如果不是内部用户 并且 agentLevel=2
    if (this._user.usertype != '0' && this._user.agentLevel == 2) {
      //判断是否是分销商（二级经销商）
      this.secondAgent = true;
    }
    this.getQycountry();

  },
  computed: {
    xsqyStr () {
      if (this.order.category2Name) {
        return this.order.categoryName + "/" + this.order.category1Name + "/" + this.order.category2Name
      } else if (this.order.category1Name) {
        return this.order.categoryName + "/" + this.order.category1Name
      }
      return this.order.categoryName
    },
  },
  methods: {
    closeIt () {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          this.showOrhide = false;
        })
      }
    },
    nextcreateNx (i) {
      if (this.status == 1) {

        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            this.showOrhide = false;
          })
        }
      }
    },
    showzhezhao () {
      ss.salesList.toshow(this.toshow).then(rd => {
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },
    getOrder (id) {
      ss.OrderMainService.selectById(id).then(rd => {
        _.assign(this.order, rd.obj)
        this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
        let type = this.order.orderCategory1;
        // 判断是否是经销商,经销商自己下单
        //当前登录人，就是经销商的话
        if (this._user.usertype == '1') {
          this.order.soldToCode = this._user.usercode;
          this.selectDailishang = false;
        }
        Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {
          if (type == '43') {
            //租赁订单
            this.showRent = true;
            this.xmcode = this.order.orderMainContract;
            if (this.order.updateFlag) {
              this.zlUpdateFlag = this.order.updateFlag;
            }
            ss.contractService.detail(this.order.orderMainContract).then(rd => {
              this.contract = rd.obj;
              if (this.contract.zltype == "3") {
                this.showJzx = true;
              }
              if (this.contract.isShhm == 1) {
                this.contract.isShhm = '1';
              } else if (this.contract.isShhm == 0) {
                this.contract.isShhm = '0';
              }
              if (this.contract.isJj == 1) {
                this.contract.isJj = '1';
              } else if (this.contract.isJj == 0) {
                this.contract.isJj = '0';
              }
              if (this.order.isChange == 1) {
                this.order.isChange = '1';
              } else if (this.order.isChange == 0) {
                this.order.isChange = '0';
              }
              if (this.order.isCancel == 1) {
                this.order.isCancel = '1';
              } else if (this.order.isCancel == 0) {
                this.order.isCancel = '0';
              }
              this.order.rentDate = rd.obj.returnTime;
              this.order.zltype = this.contract.zltype;
              this.getRentTime();
              //根据合同编号和订单类型获取代理搜信息
              ss.selectUserAgent.getOneShoudf(this.contract.customerCode).then(rd => {
                this.choseshoudf(rd, true);
              })
              if (this.order.products && this.order.products.length > 0) {
              } else {
                setTimeout(() => {
                  this.cleanOrder();
                }, 3000);
              }
            })

          }
          //存在行项目
          if (rd.obj.products && rd.obj.products.length > 0) {
            //加载完现金跟信贷，在插入行项目
            Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
              rd.obj.products.forEach((obj) => {
                if (obj) {
                  if (this.ddlx == '1,4') {
                    //添加行项目
                    if (obj.orderztype == '发货单') {
                      this.addProject(obj)
                    } else if (obj.orderztype == '退货单') {
                      this.productlist2.push(obj);
                    }
                  } else {
                    this.addProject(obj)
                  }
                  //如果是直单经销商，获取附件
                  if (this.zhidanflag == '1') {
                    uploaddown.listdownfile({ refid: obj.id, reftype: "NX_ZMFJ" }).then(rd => {
                      this.fileList2 = rd.obj;
                      this.idList.push(rd.obj.id);
                      this.order.upload2.unshift("1");
                    })
                  }
                }
                //判断是否冷库
                ss.waixiao.isLk(obj.materialCode).then(rd => {
                  this.lkFlag = rd.msg;
                  console.log("lkFlag", this.lkFlag)
                })
              })
              //重新计算信贷
              this.companyInfoList.forEach((obj) => {
                if (this['order' + obj.code].creditid) {
                  this.creditChange(this['order' + obj.code].creditid, obj.code);
                }
              })
              //原逻辑删除mark
              //  })
            })
          }
          if (rd.obj.isStandard == 2) {
            this.csFlag = true;
          }
        })
        //根据销售区域带出客户渠道
        this.order.salesregion = rd.obj.salesregion
        let value = {
          usercode: this.order.soldToCode,
          areaCode: rd.obj.salesregion,
        }
      })
    },
    //查询用户，用户余额，所有信贷
    getCredit (gscode) {
      var params = {};
      //列表中的第一个的产品大类
      var cpdl = _.uniq(_.map(this['productlist' + gscode], "proModelCode"));
      if (cpdl.length == 1) {
        params.cpdlcode = cpdl[0];
      }
      params.salegroupcode = gscode;
      params.usercode = this.order.soldToCode;
      return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
        this['order' + gscode].creditData = rd.xd;
        this['order' + gscode].xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
      })
    },
    getShoudafang (usercode) {
      if (!usercode) {
        return "";
      }
      return ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd => {
        this.choseshoudf(rd, true);
      })
    },
    choseshoudf (obj, changeflag) {
      //直单用户flag
      this.zhidanflag = obj.zhidanflag;
      this.companycodes = obj.companycodeBas;
      this.isBlood = obj.isBlood;
      //是否直单用户根据签约的公司进行选择
      this.zhidanCompanycode = [];
      this.zhidanGsCode = '';
      //设置经销商级别
      this.agentLevel = obj.agentLevel;
      this.order.agentLevel = obj.agentLevel;
      //是否直单用户并且内销标准订单 可选择公司
      //租赁订单自己选
      if (this.ddlx == '2,43') {
        //所有可选的公司
        this.companyInfoList.forEach((obj) => {
          this.zhidanCompanycode.push({
            key: obj.code,
            value: obj.name
          });
        })
        this.zhidanGsCode = '9370'
        this.chooseGscode = true;
      } else {
        this.chooseGscode = false;
      }
      this.order.soldToName = obj.username;
      this.order.soldToCode = obj.usercode;
      this.order.soldToAreaCode = obj.area;
      this.order.soldToAreaName = obj.areaname;
      this.order.gjmytk = obj.gjmytk; //国际贸易条款
      this.order.fktj = obj.fktj; //付款条件
      this.order.currencyCode = (obj.currency ? obj.currency : this.order.currencyCode) || 'CNY';
      this.showshdfdialog = false;
    },
    getRentTime () {
      var data = {
        rentType: null,
      }
      let that = this;
      if (that.contract.rentType) {
        data.rentType = this.contract.rentType;
        ss.contractService.selectRentTimeByType(data).then(rd => {
          if (rd.f) {
            that.rentTimeList = rd.msg;
          }
        })
      }
    },
    //设置租赁时间
    stRentTime () {
      let that = this;
      that.contract.contractStarttime = that.timestampToTime(new Date(this.contract.contractStarttime).getTime());// 默认开始日期
      var contractSDate = new Date(this.contract.contractStarttime);
      var nowDate = new Date();
      //若合同已开始执行并需要调整租赁时间
      if (contractSDate.getTime() <= nowDate.getTime()) {
        var contractEDate = new Date(new Date(this.contract.contractStarttime).getTime() + that.contract.rentTime * 24 * 60 * 60 * 1000);
        if (contractEDate.getTime() <= nowDate.getTime()) {
          this.$msg.msge("合同结束日期不得小于当前日期！");
          return;
        }
      }
      that.contract.contractEndtime = that.timestampToTime(new Date(this.contract.contractStarttime).getTime() + that.contract.rentTime * 24 * 60 * 60 * 1000);// 默认结束日期
      //调整租赁价格
      for (var i = 0; i < this.rentTimeList.length; i++) {
        var priceData = this.rentTimeList[i];
        if (priceData.rentTerm == this.contract.rentTime) {
          this.zulinPrice = priceData.rentPrice;
          that.contract.rentPrice = priceData.rentPrice;
          if (this['productlist' + this.zhidanGsCode]) {
            for (var j = 0; j < this['productlist' + this.zhidanGsCode].length; j++) {
              var zl = this['productlist' + this.zhidanGsCode][j];
              if (zl.priceType == 'ZL01') {
                zl.proBenchmarkPrice = priceData.rentPrice;
              }
            }
          }
        }
      }
    },
    // 时间戳转换日期
    timestampToTime (timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear();
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let D = date.getDate().toString().padStart(2, 0);
      let h = date.getHours() + ':';
      let m = date.getMinutes() + ':';
      let s = date.getSeconds();
      return Y + '-' + M + '-' + D;//+h+m+s
    },
    getQycountry () {
      let params = {}
      ss.OrderMainService.getQycountry(params).then(rd => {
        this.QYcountryList = rd;
      })
    },
    getAreaList () {
      //增加判断只允许9900000079送达方选择英国
      if (this.order.soldToCode != '9900000079' && this.order.shipToAreaCode == 'GB') {
        this.$msg.msge("送达方区域英国不可选择！");
        this.order.shipToAreaCode = null;
        return;
      }
    },
    //选择售达方
    openShoudf () {
      this.showshdfdialog = true;
    },
    //选择产品
    showProcuct1 () {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      this.showwuliaodialog1 = true;
    },
    //清空已选产品列表
    cleanOrder () {
      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })
      if (this.showJzx) {
        //如果租赁合同中只包含一个产品，则直接带出 wxwl
        let proList = {};
        if (this.contract.zlList) {
          var list = this.contract.zlList;
          //根据产品编码去重
          list = list.reduce((total, currentValue) => {
            proList[currentValue.productCode] ? '' : proList[currentValue.productCode] = total.push(currentValue);
            return total
          }, []);
          if (list.length == 1) {
            var data = {};
            var proData = {};
            data.usercode = this.order.soldToCode;
            data.ddlx = '1,8';
            data.xmcode = this.order.orderMainContract;
            data.customerChannelCode = this.order.customerChannelCode;
            data.nwsale = "2";
            data.wlcodename = list[0].productCode;
            ss.wuliaoselect.selectPage(data).then(rd => {
              proData = rd.records;
              this.choseWuliao1(proData);
            })
          } else if (list.length > 1) {
            for (let i = 0; i < list.length; i++) {
              var data = {};
              var proData = {};
              data.usercode = this.order.soldToCode;
              data.ddlx = '1,8';
              data.xmcode = this.order.orderMainContract;
              data.customerChannelCode = this.order.customerChannelCode;
              data.nwsale = "2";
              data.wlcodename = list[i].productCode;
              ss.wuliaoselect.selectPage(data).then(rd => {
                proData = rd.records;
                this.choseWuliao1(proData);
              })
            }
          }
        }
      }
    },
    choseWuliao1 (objs) {
      this.showwuliaodialog1 = false;
      for (var i = 0; i < objs.length; i++) {
        var addwl = objs[i];
        var wl = this.wlToProject(addwl);
        if (this.ddlx == '2,43') {
          if (this.contract.zlList && this.contract.zltype == '3') {
            if (this['productlist' + wl.gscode].length > 0) {
              for (var i = 0; i < this['productlist' + wl.gscode].length; i++) {
                var contractMa = this['productlist' + wl.gscode][i];
                if (contractMa.materialCode != wl.materialCode) {
                  this.$msg.msge("同一订单只能包含一个产品！");
                  return;
                }
              }
            }
            var zulins = [];
            this.contract.zlList.forEach((obj) => {
              if (obj.productCode == wl.materialCode) {
                zulins.push(obj);
              }
            })
            if (zulins) {
              for (var i = 0; i < zulins[0].rentNum; i++) {
                zulins.forEach((obj) => {
                  var newobj = _.clone(wl);
                  newobj.id = this.$util.getUuid();
                  newobj.priceType = obj.priceType;
                  newobj.proNumber = 1;//产品数量
                  newobj.proBenchmarkPrice = obj.productUnitPrice;//产品基准价
                  newobj.rentSort = i;
                  this.addProject(newobj);
                })
              }
            }
          } else {
            var newobj = _.clone(wl);
            newobj.id = this.$util.getUuid();
            this.addProject(newobj);
          }
        } else {
          //添加行项目
          this.addProject(wl);
          this.changeTejia("1", wl);
        }
        var lkData = wl.materialCode;
        //判断选中的产品是否是冷库产品
        ss.waixiao.isLk(lkData).then(rd => {
          this.lkFlag = rd.msg;
          //如果是冷库产品,则在新增时需先生成一个虚拟的预测单号用于绑定附件,点击预测单提交时更新绑定真实的预测单编号
        })
      }
      //获取遍历公司调用getCredit方法
      Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
        this.companyInfoList.forEach((obj) => {
          this['order' + obj.code].creditid = this['order' + obj.code].creditData.length > 0 ? _.first(this['order' + obj.code].creditData).id : null;
          this['order' + obj.code].orderPriceXd = 0;
        })
        //原逻辑删除mark
      })
    },
    addProject (obj) {
      console.log(obj.id + "行项目");
      var alllist = []
      //合并所有订单list
      this.companyInfoList.forEach((obj) => {
        alllist = alllist.concat(this['productlist' + obj.code]);
      })
      // 不是直单的用户，如果下液氮罐的话，必须单独下单
      if (this.zhidanflag != '1' && obj.proModelCode == 'ND1' && (this.ddlx != '1,4' && this.ddlx != '1,6')) {
        // 看看产品列表里有没有其他产品
        for (var i = 0; i < alllist.length; i++) {
          var one = alllist[i];
          if (one.proModelCode != 'ND1') {
            this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
            return;
          }
        }
      }
      if (this.zhidanflag != '1' && obj.proModelCode != 'ND1' && (this.ddlx != '1,4' && this.ddlx != '1,6')) {
        // 看看产品列表里有没有其他产品
        for (var i = 0; i < alllist.length; i++) {
          var one = alllist[i];
          if (one.proModelCode == 'ND1') {
            this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
            return;
          }
        }
      }
      if (!this.order['costCenter' + obj.gscode]) {
        this.order['costCenter' + obj.gscode] = obj.costCenter || null;
      }
      //直单用户的话 只能选择签约的公司（9390或9370）
      if (this.zhidanflag == '1' && this.ddlx != '1,6') {
        if (this.zhidanGsCode == '') {
          this.$msg.msge("该直单用户没有签约公司，请联系管理员！");
          return;
        } else {
          //如果ID是空 则默认赋值 如果不是空则取暂存的值
          if (!obj.orderId) {
            //根据用户选择公司编码 hyl
            obj.gscode = this.zhidanGsCode;
          } else {
            this.zhidanGsCode = obj.gscode;
          }
        }

      }
      this['productlist' + obj.gscode].push(obj);
      this['order' + obj.gscode].creditid = obj.xdid;
    },
    wlToProject (obj) {
      var wl = {};
      wl.id = this.$util.getUuid();
      wl.materialCode = obj.matecode;//物料编码
      wl.materialName = obj.matedes;//物料名称
      wl.proModelCode = obj.cpdlcode;//产品型号编码
      wl.proModelName = obj.cpdlname;//产品型号名称
      wl.cpz = obj.cpz; //产品组
      wl.dwcode = obj.dwcode;//单位
      wl.dwname = obj.dwname;//单位
      wl.currencyCode = this.order.currencyCode;//币种编码
      if (obj.taxCat != null && obj.taxCat != '') {
        wl.taxCat = obj.taxCat;//税分类
      } else {
        this.$msg.msge("税分类不能为空！");
        return;
      }
      wl.field = obj.field;//选择产品所在的领域
      wl.orderField = obj.field;//选择产品所在的领域
      //税率
      if (wl.taxCat == '2' || wl.taxCat == '3' || wl.taxCat == '4') {
        wl.taxRate = 1.13;
      } else if (wl.taxCat == '7') {
        wl.taxRate = 1.06;
      } else {
        wl.taxRate = 1;
      }

      if (this.contract.contractAmount != null) {
        wl.proBenchmarkPrice = this.contract.contractAmount;
        // wl.proNumber = this.contract.rentNum;

        if (this.contract.zlList) {
          if (this.contract.zltype != '3') {
            this.contract.zlList.forEach((obj) => {
              if (wl.materialCode == obj.productCode) {
                wl.proNumber = 1;
                wl.proNumber1 = obj.rentNum;
                wl.proBenchmarkPrice = obj.productUnitPrice;//产品基准价
              }
            })
          }
          if (this.contract.zltype == '3') {
            wl.rentSort = null;
          }
          wl.zltype = this.contract.zltype;
          wl.priceType = null;
        }


      } else if (this.ddlx == '1,6') {
        wl.proNumber = 1;//产品数量
        wl.proBenchmarkPrice = obj.jizhj;//产品基准价
      } else {
        wl.proNumber = 0;//产品数量
        wl.proBenchmarkPrice = obj.jizhj;//产品基准价
      }
      wl.specialOfferCode = null; // 特价版本
      wl.specialPrice = null; // 特价价格
      wl.specialPriceNum = null; // 特价价格
      wl.tjid = null; // 特价id
      wl.tjdtid = null; // 特价蛋疼id
      wl.isCustommed = 0; // 是否定制     1：是   0 否
      wl.extraPrice = null; // 定制加价
      wl.extraDes = null; // 定制需求
      wl.cwddh = null;
      //211220 公司代码根据销售样表来
      if (this.ddlx == '1,1' || this.ddlx == '1,2' || this.ddlx == '1,11') {
        if (obj.companycode == '1D90') {
          //物料销售公司是海乐苗，代理商签约1D90但未签约1RK0,则销售组织是1D90
          if (this.companycodes.indexOf('1D90') != -1 && this.companycodes.indexOf('1RK0') == -1) {
            wl.gscode = '1D90';
          } else if ((this.companycodes.indexOf('1D90') != -1 && this.companycodes.indexOf('1RK0') != -1)
            || (this.companycodes.indexOf('1D90') == -1 && this.companycodes.indexOf('1RK0') != -1)) {
            //物料销售公司是海乐苗，未签约1D90但签约1RK0或1D90和1RK0都签约了，销售公司是1RK0
            wl.gscode = '1RK0';
          } else {
            wl.gscode = obj.companycode; //公司编码
          }
        } else {
          wl.gscode = obj.companycode; //公司编码
        }
      } else {
        wl.gscode = obj.companycode; //公司编码
      }
      if (this.ddlx == '1,5' && wl.gscode == '0PN0') {
        this.ypjFlag = true;
      } else {
        this.ypjFlag = false;
      }

      wl.proType = obj.protype; //自产还是oem
      wl.cgprice = obj.cgprice; //采购价
      wl.cgmll = obj.cgmll; //采购毛利率
      wl.shareModelCode = null;
      wl.shareModelName = null;
      //售后单
      if (this.ddlx == '1,4') {
        wl.finalPrice = wl.proBenchmarkPrice;//成交价
      } else {
        wl.finalPrice = 0;//成交价
      }
      //如果是二级经销商 基准价*1.07 (暂只考虑标准订单) hyl
      if (this.ddlx == '1,2' && (wl.gscode == '9390' || wl.gscode == '9370' || wl.gscode == '1RK0')) {
        if (this.agentLevel == 2) {
          wl.proBenchmarkPrice = new big(wl.proBenchmarkPrice).times(1.07).toFixed(2).toString()
        }
      }
      wl.totalprice = 0;//产品总价
      wl.tjlist = obj.tjlist;//特价list
      wl.expoPrice = obj.expoPrice;
      wl.fromtype = obj.fromtype;
      wl.smList = obj.smList;
      //如果是样品机
      if (this.ddlx == '1,5') {
        wl.factory = obj.werks;
      } else {
        wl.factory = obj.factory;
      }
      wl.cpdlcode = obj.cpdlcode;
      wl.xiaoe = obj.xiaoe;
      wl.jishu = obj.jishu;
      wl.lianqun = obj.lianqun;
      wl.oemDesc = obj.oemDesc;
      return wl;
    },
    getProductlist (code) {
      return this['productlist' + code];
    },
    chooseGsCode (code) {
      //将其他公司的数据赋值给选择的公司
      this.companyInfoList.forEach((obj) => {
        if (obj.code != code) {
          this['productlist' + obj.code].forEach((obj) => {
            this['productlist' + code].push(obj);
          })
          //清空其他公司信息
          this['productlist' + obj.code] = [];
        }
      })
      //将所有物料的公司编码改成选择的
      for (var i = 0; i < this['productlist' + code].length; i++) {
        this['productlist' + code][i].gscode = code;
      }
    },
    //修改共享大类
    changeShareModel (scode, row) {
      if (row.shareModelCode) {
        const smobj = _.find(row.smList, { shareModelCode: row.shareModelCode })
        row.shareModelName = smobj.shareModelName;
      } else {
        row.shareModelName = null;
      }
    },
    getRentPrice (v, index) {
      if (v.priceType == 'ZL03' || v.priceType == 'ZL05') {
        var contractSDate = new Date(this.contract.contractStarttime);
        var nowDate = new Date();
        //若合同已开始执行并需要调整租赁时间
        /*                    if(contractSDate.getTime() <= nowDate.getTime()){
                                this.$msg.msge("合同已开始执行，不允许选择当前费用类型！");
                                return;
                            }*/
      }
      var repeatFlag = false;
      //租赁费的话,根据租赁类型和租赁天数获取租赁价格
      if (v.code == 'ZL01') {
        if (this.zulinPrice != '' && this.zulinPrice != null) {
          this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = this.zulinPrice;
        } else {
          this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = 0;
        }
        //根据费用类型和天数获取价格
        var data = {
          rentType: null,
          rentTerm: 0,
        }
        data.rentType = this.contract.rentType;
        data.rentTerm = this.contract.rentTerm;
        ss.contractService.selectRentTimeByType(data).then(rd => {
          if (rd.f) {
            this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = rd.msg[0].rentPrice;
          }
        })
      } else {
        //根据费用类型获取价格
        var data = {
          priceType: null,
          isShhm: 0,
          isJj: 0,
        }
        data.priceType = v.code;
        if (data.priceType == 'ZL05') {
          data.isJj = 1;
        } else if (data.priceType == 'ZL08') {
          data.isShhm = 1;
        }
        ss.contractService.selectByRentType(data).then(rd => {
          if (rd.f) {
            var list = rd.msg;
            if (v.code == 'ZL04') {
              //判断合同是执行中还是开始前两天
              var contractSDate = new Date(this.contract.contractStarttime);
              var nowDate = new Date();
              //若合同已开始执行并需要调整租赁时间
              if (contractSDate.getTime() <= nowDate.getTime()) {
                this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = list[0].allPrice;
              } else {
                this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = list[0].untiPrice;
              }
            } else {
              this['productlist' + this.zhidanGsCode][index].proBenchmarkPrice = list[0].untiPrice;
            }

          }
        })
      }
    },
    adds () {
      if (this['productlist' + this.zhidanGsCode]) {
        var data = this['productlist' + this.zhidanGsCode][0];
        var contractPrice = JSON.parse(JSON.stringify(data));
        contractPrice.priceType = null;
        contractPrice.proBenchmarkPrice = new big(0);
        contractPrice.id = this.$util.getUuid();
        contractPrice.status = '10';
        contractPrice.cwddh = '';
        this['productlist' + this.zhidanGsCode].push(contractPrice);
      }
    },
    //根据公司编码返回OrderName
    getOrderName (code) {
      return this['order' + code];
    },
    // 选择具体的信贷
    creditChange (v, gscode) {
      console.log("默认选中信贷", v, gscode)
      if (v) {
        var orderje = this['order' + gscode].orderPrice;
        var xd = _.find(this['order' + gscode].creditData, { id: v })
        var xdye = xd.quota;
        //用户的现金余额
        var xjye = this['order' + gscode].xianjye;
        if (xjye > 0) {
          if (xjye >= orderje) {
            this['order' + gscode].creditid = null;
            this['order' + gscode].orderPriceXd = 0;
          } else {
            //现金+信贷>订单金额
            if (xdye + xjye > orderje) {
              this['order' + gscode].orderPriceXd = orderje - xjye;
            } else {
              if (orderje - xjye < xdye) {
                this['order' + gscode].orderPriceXd = orderje - xjye;
              } else {
                this['order' + gscode].orderPriceXd = xdye;
              }
            }
          }
        } else {
          //信贷金额，大于订单总额
          if (xdye >= orderje) {
            this['order' + gscode].orderPriceXd = orderje;
          } else {
            //订单减掉现金余额
            this['order' + gscode].orderPriceXd = xdye;
          }
        }
      } else {
        this['order' + gscode].creditid = null;
        this['order' + gscode].orderPriceXd = 0;
      }
    },
    deleteThis (row) {
      var id = row.id;
      var gscode = row.gscode;
      this.$msg.confirm("确认删除？", () => {
        this['productlist' + gscode] = _.reject(this['productlist' + gscode], { 'id': id });
        //合并所有订单list
        this.order.products = [];
        this.companyInfoList.forEach((obj) => {
          this.order.products = this.order.products.concat(this['productlist' + obj.code]);
        })
        // 删除的时候,没有一个了，肯定是false
        this.ydgFlag = this.order.products.length == 0 ? false : this.ydgFlag;
      })
    },
    backtolist () {
      this.$router.go(-1);
    },
    saveOrSubmit (v) {
      this.order.orderStatus = v
      if (v == '10') {
        this.order.submitflag = '暂存'
        this.order.newId = null
      } else if (v == '20') {
        this.order.submitflag = '提交'
        this.order.newId = null
      } else if (v == '30') {
        this.order.orderStatus = 20;
        this.order.newId = this.$route.query.ywid
        this.order.submitflag = '重新提报'
      }
      var flag = true;
      //每次提交或者暂存将值清零 防止累加 hyl
      this.order.orderPrice = 0;
      this.order.orderPriceRbm = 0;
      this.companyInfoList.forEach((obj) => {
        _.forEach(this['productlist' + obj.code], (value) => {
          if (this.showRent) {
            if (this.order.businessReason == "" || this.order.businessReason == null) {
              this.$msg.msge("请维护业务原因！");
              flag = false;
            }
            if (value.cwddh == "" || value.cwddh == null) {
              this.$msg.msge("请维护财务订单号！");
              flag = false;
            }
          }
          value.xdid = this['order' + obj.code].creditid
          value.totalpricermb = value.totalprice;
          value.costCenter = this.order['costCenter' + obj.code];

          this.order.orderPrice = new big(this.order.orderPrice || 0).plus(value.totalprice || 0);
          this.order.orderPriceRbm = new big(this.order.orderPriceRbm || 0).plus(value.totalprice || 0);
          //如果是分销商（二级经销商）成交价,净价值,计算总价 hyl
          if (this.secondAgent == true) {
            value.finalPrice = new big(value.specialPrice || value.expoPrice || value.proBenchmarkPrice * value.discount || value.proBenchmarkPrice).plus(value.extraPrice || 0).toFixed(2).toString()
            value.jinejjz = new big(value.finalPrice).div(value.taxRate).toFixed(2).toString()
            value.totalprice = new big(value.proNumber || 0).times((value.finalPrice || 0)).toFixed(2).toString()
          }
        });
      })
      //计算所有订单现金占用
      this.order.orderPriceXj = this.companyInfoList.reduce((total, item) => {
        return new big(total).plus(new big(this['order' + item.code].orderPriceXj || 0)).toString();
      }, 0)
      //计算所有订单信贷占用
      this.order.orderPriceXd = this.companyInfoList.reduce((total, item) => {
        return new big(total).plus(new big(this['order' + item.code].orderPriceXd || 0)).toString();
      }, 0)
      //计算所有订单净价值
      this.order.orderNetWorth = this.companyInfoList.reduce((total, item) => {
        return new big(total).plus(new big(this['order' + item.code].orderNetWorth || 0)).toString();
      }, 0)
      //合并所有订单list
      this.order.products = [];
      this.companyInfoList.forEach((obj) => {
        this.order.products = this.order.products.concat(this['productlist' + obj.code]);
      })
      this.order.products2 = this.productlist2;
      if (flag) {
        if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
          this.$refs['form1'].validate((valid1) => {
            if (valid1) {
              this.$msg.confirm("确认提交？", () => {
                console.log(this.order)
                if (this.zlUpdateFlag) {
                  this.updateZlOrder();
                } else {
                  this.submitForm();
                }
              })
            } else {
              this.$msg.msge("请完善基本信息后提交");
              return;
            }
          });
        } else {
          this.submitForm();
        }
      }
    },
    updateZlOrder () {
      if (this.submitChongfuFlag) {
        this.submitChongfuFlag = false;
        ss.OrderMainService.commitContainer(this.order).then(rd => {
          this.submitChongfuFlag = true;
          if (rd.f) {
            if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
              this.$msg.msgs("提交成功！")
              this.$router.push({ path: '/dingd/dingdmainlist' })
            } else {
              this.$msg.msgs("暂存成功！")
            }
          } else {
            this.$msg.msge(rd.msg);
          }
        })
      } else {
        this.$msg.msge("重复点击提交，请稍后操作！");
      }
    },
    submitForm () {
      if (this.submitChongfuFlag) {
        if (this.order.tuihyydes == '' || this.order.tuihyydes == null) {
          this.order.tuihyydes = '检测'
        }
        console.log(this.order)
        this.submitChongfuFlag = false;
        ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
          this.submitChongfuFlag = true;
          if (rd.f) {
            if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
              this.$msg.msgs("提交成功！")
              //二级经销商订单条二级经销商页面
              if (this.agentLevel == 2) {
                this.$router.push({ path: '/dingd/secondDingdmainlist' })
              } else {
                this.$router.push({ path: '/dingd/dingdwxlist' })
              }
            } else {
              this.$msg.msgs("暂存成功！")
            }
          } else {

            this.$msg.msge(rd.msg);
          }
        })

      } else {
        this.$msg.msge("重复点击提交，请稍后操作！");
      }
    },
    viewpress (r) {
      this.showhistory = true;
    },
    resaveOrSubmit (v) {
      this.saveOrSubmit(30);
    },
  },
}
</script>
<style scoped>
.jieguo {
  border-bottom: 1px solid rgb(238, 236, 236);
  display: flex;
}

.jieguo .jieguo_label {
  width: 2rem;
  text-align: right;
  background-color: #ebf5ff;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.05rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jieguo .jieguo_value {
  width: 19%;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0px 8px;
}
.n-xiao .h-formbLine .h-elformWrap-2,
.n-two .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}
.n-xiao .h-formbLine .h-elformWrap-z,
.n-two .h-formbLine .h-elformWrap-z {
  width: 29%;
}
.n-xiao .h-formbLine .h-elformWrap-m,
.n-two .h-formbLine .h-elformWrap-m {
  width: 2%;
}
.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style>
</style>
<style scoped lang="scss">
</style>
